import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

const serviceAreas = [
  {
    state: "West Virginia",
    cities: [
      { name: "Martinsburg", href: "/service-areas/martinsburg-wv" },
      { name: "Inwood", href: "/service-areas/inwood-wv" },
      { name: "Falling Waters", href: "/service-areas/falling-waters-wv" },
      { name: "Hedgesville", href: "/service-areas/hedgesville-wv" },
      { name: "Berkeley Springs", href: "/service-areas/berkeley-springs-wv" },
      { name: "Charles Town", href: "/service-areas/charles-town-wv" },
      { name: "Ranson", href: "/service-areas/ranson-wv" },
      { name: "Kearneysville", href: "/service-areas/kearneysville-wv" },
      { name: "Harpers Ferry", href: "/service-areas/harpers-ferry-wv" },
      { name: "Bunker Hill", href: "/service-areas/bunker-hill-wv" },
      { name: "Shepherdstown", href: "/service-areas/shepherdstown-wv" },
    ],
  },
  {
    state: "Virginia",
    cities: [
      { name: "Winchester", href: "/service-areas/winchester-va" },
      { name: "Berryville", href: "/service-areas/berryville-va" },
      { name: "Stephens City", href: "/service-areas/stephens-city-va" },
    ],
  },
];

const countyPages = [
  { name: "Berkeley County, WV", href: "/service-areas/berkeley-county" },
  { name: "Jefferson County, WV", href: "/service-areas/jefferson-county" },
  { name: "Frederick County, VA", href: "/service-areas/frederick-county" },
  { name: "Washington County, MD", href: "/service-areas/washington-county" },
];

const ServiceAreaSection = () => {
  return (
    <section className="section-padding bg-muted relative overflow-hidden">
      <div className="container-custom relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-secondary mb-4">
            PROUDLY <span className="text-primary">SERVING</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Professional pressure washing across the tri-state area
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-10">
          {serviceAreas.map((area) => (
            <div key={area.state} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <h3 className="text-xl font-bold font-heading text-secondary mb-4 flex items-center gap-2">
                <MapPin className="w-5 h-5 text-primary" />
                {area.state}
              </h3>
              <ul className="space-y-2">
                {area.cities.map((city) => (
                  <li key={city.name}>
                    <Link to={city.href} className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-2">
                      <span className="w-1.5 h-1.5 bg-primary rounded-full" />
                      {city.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* County Pages */}
        <div className="text-center mb-6">
          <h3 className="text-xl font-bold font-heading text-secondary mb-4">County Service Areas</h3>
          <div className="flex flex-wrap justify-center gap-3">
            {countyPages.map((county) => (
              <Link key={county.name} to={county.href} className="bg-white px-4 py-2 rounded-lg shadow hover:shadow-md transition-shadow text-muted-foreground hover:text-primary font-medium">
                {county.name}
              </Link>
            ))}
          </div>
        </div>

        <p className="text-center text-muted-foreground mt-8">And surrounding areas within 30 miles</p>
      </div>
    </section>
  );
};

export default ServiceAreaSection;
